export const SET_TEMPLATE_VARIABLES_PATH_TOOL_NAME =
  "set_template_variables_path";
